import React from 'react';
import { motion } from 'framer-motion';
import { Droplets, Wind, Sprout, Activity, Carrot, Leaf } from 'lucide-react';
const ingredients = [{
  icon: <Droplets className="w-6 h-6 text-forest" data-id="element-96" />,
  title: 'Lösliche Ballaststoffe',
  subtitle: '(Inulin, Johannisbrotmehl)',
  desc: 'Binden Wasser, machen den Stuhl weicher und voluminöser.'
}, {
  icon: <Wind className="w-6 h-6 text-forest" data-id="element-97" />,
  title: 'Unlösliche Ballaststoffe',
  subtitle: '(Leinsamen)',
  desc: 'Beschleunigen die Darmpassage auf mechanische Weise.'
}, {
  icon: <Sprout className="w-6 h-6 text-forest" data-id="element-98" />,
  title: 'Topinambur',
  subtitle: 'Präbiotikum',
  desc: 'Regt die Darmbewegung durch gesunde Bakterienaktivität an.'
}, {
  icon: <Activity className="w-6 h-6 text-forest" data-id="element-99" />,
  title: 'Artischocke',
  subtitle: 'Verdauungsfördernd',
  desc: 'Fördert den Gallenfluss für eine bessere Fettverdauung.'
}, {
  icon: <Carrot className="w-6 h-6 text-forest" data-id="element-100" />,
  title: 'Möhrenmehl',
  subtitle: 'Pektinquelle',
  desc: 'Reguliert die Darmpassagezeit auf natürliche Weise.'
}];
export function ProductExplanation() {
  return <section className="w-full py-16 px-4 bg-white/50 border-y border-brown/10" data-id="element-101">
      <div className="max-w-4xl mx-auto" data-id="element-102">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-103">
          <h2 className="font-handwriting text-4xl md:text-5xl text-forest font-bold mb-4" data-id="element-104">
            Warum manche Hunde einen trägen Darm haben – und was hilft
          </h2>
          <p className="font-serif text-lg text-gray-700 max-w-2xl mx-auto" data-id="element-105">
            Eine gesunde Darmpassage und Peristaltik (Darmbewegung) sind
            entscheidend. Wenn der Darm zu langsam arbeitet, helfen diese
            natürlichen Helfer:
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-10" data-id="element-106">
          {ingredients.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-cream-card p-6 rounded-xl shadow-sm border border-brown/5 flex flex-col items-center text-center" data-id="element-107">
              <div className="w-12 h-12 bg-cream rounded-full flex items-center justify-center mb-4 shadow-inner" data-id="element-108">
                {item.icon}
              </div>
              <h3 className="font-serif font-bold text-gray-800 text-lg" data-id="element-109">
                {item.title}
              </h3>
              <span className="text-sm text-brown mb-2 font-medium" data-id="element-110">
                {item.subtitle}
              </span>
              <p className="font-serif text-gray-600 text-sm" data-id="element-111">{item.desc}</p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="flex items-center justify-center gap-2 text-forest font-bold font-serif text-lg bg-cream-card py-4 px-6 rounded-full w-fit mx-auto shadow-sm border border-forest/20" data-id="element-112">
          <Leaf className="w-5 h-5" data-id="element-113" />
          100% pflanzlich, keine künstlichen Zusätze
        </motion.div>
      </div>
    </section>;
}